import { Box, LinearProgress, Typography } from "@mui/material";

export const QuotaProgressBar = ({
  currentValue,
  quota,
  id,
}: {
  currentValue: number;
  quota: number;
  id: string;
}) => {
  let normalizedValue = 0;
  if (quota) {
    normalizedValue = currentValue < quota ? (currentValue / quota) * 100 : 100;
  }
  return (
    <Box>
      <Box sx={{ px: 0.5, width: "100%" }}>
        <LinearProgress
          variant="determinate"
          value={normalizedValue}
          color={quota && currentValue > quota ? "warning" : "primary"}
        />
      </Box>
      <Box sx={{ px: 0.5 }}>
        <Typography
          variant="body2"
          color="text.secondary"
          data-test={`${id}`}
        >{`${currentValue} of ${quota}`}</Typography>
      </Box>
    </Box>
  );
};
